import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Layout from '../components/Layout';
import ContactPicker from '../components/ContactPicker';
import {api} from '../../api';

const PRIORITY_COLORS = { HIGH: 'bg-red-100 text-red-800', MEDIUM: 'bg-yellow-100 text-yellow-800', LOW: 'bg-green-100 text-green-800' };
const STATUS_COLORS = { TODO: 'bg-gray-100 text-gray-800', IN_PROGRESS: 'bg-blue-100 text-blue-800', DONE: 'bg-green-100 text-green-800' };

export default function CrmTasks() {
  const [tasks, setTasks] = useState([]);
  const [filter, setFilter] = useState('ALL');
  const [assignee, setAssignee] = useState(null);

  // Filtering happens server-side; refetch whenever a filter changes.
  useEffect(() => {
    let current = true;
    const params = new URLSearchParams();
    if (filter !== 'ALL') params.set('status', filter);
    if (assignee) params.set('subtaskContactId', assignee.id);
    const qs = params.toString();
    api(`/crm-tasks${qs ? `?${qs}` : ''}`).then(r => r.json()).then(data => { if (current) setTasks(data); });
    return () => { current = false; };
  }, [filter, assignee]);

  return (
    <Layout>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Tasks</h1>
        <div className="flex items-center gap-3">
          <select value={filter} onChange={(e) => setFilter(e.target.value)} className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600">
            <option value="ALL">All</option>
            <option value="TODO">To Do</option>
            <option value="IN_PROGRESS">In Progress</option>
            <option value="DONE">Done</option>
          </select>
          <Link to="/crm/tasks/new" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">+ New Task</Link>
        </div>
      </div>
      <div className="mb-6 w-full sm:max-w-md">
        <label className="block text-sm font-medium text-gray-700 mb-1">Subtask assignee</label>
        {/* ContactPicker is multi-select; keep only the most recently picked contact. */}
        <ContactPicker selected={assignee ? [assignee] : []} onChange={(list) => setAssignee(list.length > 0 ? list[list.length - 1] : null)} />
      </div>
      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Task</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Subtasks</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Due</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Priority</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Contacts</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Deal</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {tasks.map((t) => (
              <tr key={t.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap font-medium">
                  <Link to={`/crm/tasks/${t.id}`} className="text-blue-600 hover:text-blue-800">{t.title}</Link>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-gray-600 hidden md:table-cell">
                  {t.subtasks && t.subtasks.length > 0 ? `${t.subtasks.filter(s => s.completed).length} / ${t.subtasks.length}` : '—'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-gray-600">{t.dueDate || '—'}</td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${PRIORITY_COLORS[t.priority] || ''}`}>{t.priority}</span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${STATUS_COLORS[t.status] || ''}`}>{t.status.replace(/_/g, ' ')}</span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-gray-600 hidden md:table-cell">
                  {t.contacts && t.contacts.length > 0 ? t.contacts.map((c, i) => (
                    <span key={c.id}>{i > 0 && ', '}<Link to={`/crm/contacts/${c.id}`} className="text-blue-600 hover:text-blue-800">{c.firstName} {c.lastName}</Link></span>
                  )) : '—'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-gray-600 hidden md:table-cell">
                  {t.dealId ? <Link to={`/crm/deals/${t.dealId}`} className="text-blue-600 hover:text-blue-800">{t.dealName}</Link> : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {tasks.length === 0 && (
          <div className="text-center py-12 text-gray-500">No tasks found.</div>
        )}
      </div>
    </Layout>
  );
}
